import styled from 'styled-components';

export const Container = styled.div`
   display: flex;
   .icon-size{
      font-size: 1rem;
   }
`
export const CheckRead = styled.div`
   display: flex;
   justify-content: center;
   align-items:center;
   color: #3e55ea;
`